import React, { Component } from "react";
import { withRouter } from "../../withRouter";
import Utils from "../../provider/Utils";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import TextField from "@material-ui/core/TextField";
import AddressWithTimezone from "../addressWithTimezone/AddressWithTimezone";
import { ValidatorForm } from "react-material-ui-form-validator";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { MenuWithBreadScrum } from "../menu/MenuWithBreadScrum";
import { InputAdornment } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import SaveButton from "../buttons/SaveButton";
import BackButton from "../buttons/BackButton";
import CancelIconButton from "../buttons/CancelIconButton";
import FetchServerData from "../../provider/FetchServerData";
import PtsAlert from "../ptsAlert/PtsAlert";
import store from "../../redux/store";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import "./Supplier.css";
import CreateButton from "../buttons/CreateButton";
import ApplicationStateAction from "../../redux/applicationState/ApplicationStateAction";
import Pagination from "../assetTracking/Pagination";
import _ from "lodash";
import PtsButton from "../buttons/PtsButton";
import CatalogueDialog from "../catalogueManagement/CatalogueDialog";

class Supplier extends Component {
  header = store.getState().header.header;
  supplierTypeList = store.getState().staticData.supplierTypeList;
  profileType = store.getState().appUserData.appUserData?.profile?.profileType;
  addressRef = React.createRef();
  breadCrumb = [
    { pageid: "/supplierList", uiname: "Supplier List" },
    { pageid: "", uiname: "Supplier Details" },
  ];
  suppAssetsState = store.getState().applicationState.suppAssetsState;
  suppAssetsStateDetails = {};
  constructor(props) {
    super(props);
    if (this.suppAssetsState) {
      this.suppAssetsStateDetails = Object.getOwnPropertyNames(
        this.suppAssetsState
      );
    }
    let action = "";
    let supplierId = "";
    if (!action && props.state) {
      action = props.state.action;
      supplierId = props.state.supplierId;
    }
    if (
      action &&
      Utils.equalsIgnoreCase(
        action,
        "view" || Utils.equalsIgnoreCase(action, "update")
      )
    ) {
      this.getSupplierDetails(supplierId);
    }

    if (this.suppAssetsStateDetails.length > 0) {
      this.state = {
        action: action,
        supplierId: supplierId,
        supplier: null,
        assetCount: 0,
        name: "",
        panNo: "",
        gstn: "",
        email: "",
        phone: "",
        description: "",
        address: {},
        supplierType: "",
        supplierTypeId: null,
        selectedTab: this.suppAssetsState.selectedTab,
        pageNo: this.suppAssetsState.pageNo,
        showPerPage: this.suppAssetsState.pageSize,
        totalPages: this.suppAssetsState.totalPages,
        totalRecords: this.suppAssetsState.total,
        isStatus: true,
        render: false,
        getUpdatePermission: false,
        getDeletePermission: false,
      };
      if (action && Utils.equalsIgnoreCase(action, "view")) {
        this.getSupplierAssetsList(
          this.suppAssetsState.pageNo,
          this.suppAssetsState.pageSize
        );
        this.debouncedSearch = _.debounce(this.getSupplierAssetsList, 800);
      }
    } else {
      this.state = {
        action: action,
        supplierId: supplierId,
        name: "",
        panNo: "",
        gstn: "",
        email: "",
        phone: "",
        description: "",
        address: {},
        supplierType: "",
        supplierTypeId: null,
        assetCount: 0,
        selectedTab: 0,
        pageNo: 0,
        showPerPage: 10,
        totalPages: 0,
        totalRecords: 0,
        isStatus: true,
        render: false,
        getUpdatePermission: false,
        getDeletePermission: false,
      };
      if (action && Utils.equalsIgnoreCase(action, "view")) {
        this.getSupplierAssetsList(0, 10);
        this.debouncedSearch = _.debounce(this.getSupplierAssetsList, 800);
      }
    }
  }
  getSupplierDetails(supplierId) {
    const postObject = {
      header: this.header,
      supplier: {
        id: supplierId,
      },
    };

    FetchServerData.callPostService("/supplierms/get", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let supplierDetails = output.data.supplier;
          let getPermission = Utils.getRolePermission(
            output.data.privilegeList
          );
          let getUpdatePermission = getPermission[3];
          let getDeletePermission = getPermission[4];
          let supplierStatus = "";
          if (supplierStatus === null) {
            supplierStatus = false;
          } else {
            if (supplierDetails.supStatus?.status === "Active") {
              supplierStatus = true;
            } else {
              supplierStatus = false;
            }
          }
          this.setState({
            render: true,
            action: "view",
            id: supplierDetails.id,
            name: supplierDetails.name,
            panNo: supplierDetails.pan,
            gstn: supplierDetails.gstn,
            email: supplierDetails.email,
            phone: supplierDetails.phone,
            description: supplierDetails.description,
            assetCount: supplierDetails.assetCount,
            address: supplierDetails.address,
            supplierType: supplierDetails.suppliertype,
            supplierTypeId: supplierDetails.suppliertype.id,
            isStatus: supplierStatus,
            supplierStatus: supplierDetails.supStatus?.status,
            getUpdatePermission: getUpdatePermission,
            getDeletePermission: getDeletePermission,
          });
        }
      }
    );
  }
  handleStatusChange = (e) => {
    this.setState({ supplierStatus: e.target.value });
  };
  viewCancel() {
    this.props.navigate("/supplierList");
  }
  handleSupplierTypeChange(e) {
    this.setState({
      supplierType: e.target.value === 1 ? "Registered" : "UnRegistered",
      supplierTypeId: e.target.value,
    });
  }

  handleNameChange(e) {
    this.setState({ name: e.target.value });
  }
  handleGstnChange(e) {
    if (e.target.value.length === 15) {
      this.setState({ panNo: e.target.value?.toUpperCase().substring(2, 12) });
    }
    this.setState({ gstn: e.target.value?.toUpperCase() });
  }

  handlePanNoChange(e) {
    let res = e.target.value?.toUpperCase();
    if (res.length <= 10) {
      this.setState({ panNo: res });
    } else {
      Utils.maxFieldLength(10);
    }
  }
  handleEmailChange(e) {
    this.setState({ email: e.target.value });
  }
  handlePhoneChange(e) {
    let res = e.target.value;
    if (res.length <= 10) {
      this.setState({ phone: res });
    }
  }
  handleDescriptionChange(e) {
    this.setState({ description: e.target.value });
  }
  handleAddressChange(address) {
    this.setState({ address: address });
  }
  createSupplierToBackend() {
    if (!Utils.checkPanLength(this.state.panNo)) {
      return;
    }

    if (this.state.gstn.length > 0) {
      if (!Utils.checkGstnLength(this.state.gstn)) {
        return;
      }
    }
    const postObject = {
      header: this.header,
      supplier: {
        name: this.state.name,
        gstn: this.state.gstn,
        email: this.state.email,
        phone: this.state.phone,
        pan: this.state.panNo,
        description: this.state.description,
        address: {
          line: this.addressRef.current.state.line,
          state: {
            name: this.addressRef.current.state.state.name,
            code: this.addressRef.current.state.state.code,
            id: this.addressRef.current.state.state.id,
            country: this.addressRef.current.state.country,
          },
          city: this.addressRef.current.state.city,
          zipcode: this.addressRef.current.state.zipCode,
          latitude: this.addressRef.current.state.latitude,
          longitude: this.addressRef.current.state.longitude,
        },
        suppliertype: {
          id: this.state.supplierTypeId,
          type: this.state.supplierType,
        },
      },
    };
    FetchServerData.callPostService("/supplierms/create", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let supplierData = output.data.supplier;
          this.getSupplierDetails(supplierData.id);
          this.setState({
            action: "view",
          });
        }
      }
    );
  }
  createCancel() {
    this.props.navigate("/supplierList");
  }

  editSupplierDetails(e) {
    this.setState({ action: "edit", supplierId: this.state.id });
  }
  updateSupplierToBackend() {
    let supStatus;
    if (this.state.isStatus === true) {
      supStatus = "Active";
    } else {
      supStatus = "InActive";
    }
    if (!Utils.checkPanLength(this.state.panNo)) {
      return;
    }
    if (this.state.gstn.length > 0) {
      if (!Utils.checkGstnLength(this.state.gstn)) {
        return;
      }
    }
    const postObject = {
      header: this.header,
      supplier: {
        name: this.state.name,
        email: this.state.email,
        gstn: this.state.gstn,
        phone: this.state.phone,
        pan: this.state.panNo,
        id: this.state.supplierId,
        description: this.state.description,
        address: {
          id: this.addressRef.current.state.id,
          line: this.addressRef.current.state.line,
          state: {
            name: this.addressRef.current.state.state.name,
            code: this.addressRef.current.state.state.code,
            id: this.addressRef.current.state.state.id,
            country: this.addressRef.current.state.country,
          },
          city: this.addressRef.current.state.city,
          zipcode: this.addressRef.current.state.zipCode,
          latitude: this.addressRef.current.state.latitude,
          longitude: this.addressRef.current.state.longitude,
        },
        suppliertype: {
          id: this.state.supplierTypeId,
          type: this.state.supplierType.type,
        },
        supStatus: {
          status: this.state.supplierStatus,
        },
      },
    };
    FetchServerData.callPostService("/supplierms/update", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.getSupplierDetails(this.state.supplierId);
          this.setState({
            action: "view",
          });
        }
      }
    );
  }

  editCancel() {
    this.getSupplierDetails(this.state.id);
    // this.setState({
    //   action: "view",
    // })
  }

  deleteSupplierToBackend() {
    const postObject = {
      header: this.header,
      supplier: {
        id: this.state.supplierId,
      },
    };
    FetchServerData.callPostService("/supplierms/delete", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.props.navigate("/supplierList");
        }
      }
    );
  }

  getGstn() {
    if (!this.state.gstn) {
      PtsAlert.error("Enter GSTN");
      return;
    }
    const postObject = {
      gstin: this.state.gstn,
      header: this.header,
    };
    FetchServerData.callPostService("/staticms/findByGstn", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let gstnDetails = output.data.taxpayer;
          PtsAlert.success(output.message);
          this.setState({
            name: gstnDetails.legalname,
            state: gstnDetails.address?.state,
            address: gstnDetails.address,
          });
        }
      }
    );
  }

  setKey = (tab) => {
    this.setState({
      selectedTab: tab,
    });
  };

  getSupplierAssetsList(pageNo, pageSize) {
    const postObject = {
      header: this.header,
      supplier: {
        id: this.state.supplierId,
      },
      page: {
        searchText: this.state.search,
        pageNo: pageNo,
        pageSize: pageSize,
      },
    };

    FetchServerData.callPostService(
      "/supplierms/getAssetList",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let supplierAssetList = output.data.assetList;
        let page = output.data.page;
        let isPaging = false;
        if (supplierAssetList.length > this.state.pageSize) {
          isPaging = true;
        }
        this.setState({
          render: true,
          isPaging: isPaging,
          supplierAssetList: supplierAssetList,
          initialPage: this.state.initialPage,
          pageNo: page?.pageNo,
          showPerPage: page?.pageSize,
          totalPages: page?.totalPages,
          totalRecords: page?.total,
        });
      }
    });
  }

  viewAsset = (e, data) => {
    let suppAssetsState = {
      assetId: data.id,
      pageNo: this.state.pageNo,
      showPerPage: this.state.pageSize,
      totalPages: this.state.totalPages,
      totalRecords: this.state.total,
      selectedTab: this.state.selectedTab,
    };
    store.dispatch(
      ApplicationStateAction.setApplicationState({ suppAssetsState })
    );
    this.props.navigate("/asset", {
      state: {
        action: "view",
        assetId: data?.id,
        supplierId: data?.supplierid,
        pageId: "supplierAssets",
      },
    });
  };

  assetTrackingStatus(trackingHistoryStatus) {
    switch (trackingHistoryStatus) {
      case "Active":
        return <span className="dot"></span>;
      case "NotTracked":
        return <span className="dot"></span>;
      case "Tracked":
        return <span className="greendot"></span>;
      case "HoldingPeriodOver":
        return <span className="yellowdot blink_me"></span>;
      case "CycleTimeOver":
        return <span className="orangedot blink_me"></span>;
      case "MissingAsset":
        return <span className="reddot blink_me"></span>;
      default:
    }
  }

  onPaginationChange(returnProp) {
    let counter = returnProp.counter;
    let pageNo = this.state.pageNo + counter;
    let pageSize = returnProp.showPerPage;
    let buttonIndex = returnProp.buttonIndex;
    let currentPageIndex =
      typeof counter !== "undefined" ? pageNo : buttonIndex;
    let resetPageNo = returnProp.resetPageNo;
    if (resetPageNo === true) {
      currentPageIndex = 0;
    }
    this.setState({
      pageNo: currentPageIndex,
      showPerPage: pageSize,
    });
    this.getSupplierAssetsList(currentPageIndex, pageSize);
    this.handleMaterialTablePageChange(currentPageIndex, pageSize);
  }
  onSearchChange(e) {
    this.setState({ search: e.target.value });
    this.debouncedSearch(0, this.state.showPerPage);
  }
  onSearchClick() {
    this.setState({
      isFirstTimeLoading: false,
    });
    this.getSupplierAssetsList(
      this.state.pageNo,
      this.state.showPerPage,
      this.state.search
    );
  }

  handleAssetCodeChange(selectedAssetCode) {
    this.setState({
      assetCode: selectedAssetCode,
    });
  }

  toCategoryDetails() {
    if (this.catalogueDialogueRef && this.catalogueDialogueRef.current) {
      this.catalogueDialogueRef.current.GetCatalogueWithSubcategorie();
    }
  }

  toCreateAsset(categoryId, catalogueId) {
    let suppAssetsState = {
      assetId: "",
      pageNo: this.state.pageNo,
      showPerPage: this.state.pageSize,
      totalPages: this.state.totalPages,
      totalRecords: this.state.total,
      selectedTab: this.state.selectedTab,
    };
    store.dispatch(
      ApplicationStateAction.setApplicationState({ suppAssetsState })
    );
    this.props.navigate("/asset", {
      state: {
        action: "create",
        categoryId: categoryId,
        catalogueId: catalogueId,
        supplier: { id: this.state.supplierId, name: this.state.name },
        supplierId: this.state.supplierId,
        pageId: "supplierAssets",
      },
    });
  }

  render() {
    this.catalogueDialogueRef = React.createRef();
    if (this.state.action === "create") {
      return this.createSupplier();
    } else if (this.state.action === "edit") {
      return this.editSupplier();
    } else if (this.state.action === "view") {
      return this.viewSupplier();
    }
  }
  createSupplier() {
    return (
      <>
        <MenuWithBreadScrum
          breadCrumb={this.breadCrumb}
          navigate={this.props.navigate}
          domainObject="Supplier"
          name="Create Supplier"
        />
        <div className="row">
          <ValidatorForm
            className="text-start"
            ref="form"
            onSubmit={this.createSupplierToBackend.bind(this)}
          >
            <div className="row">
              <div className="col-md-12">
                <div className="card " id="organizationFormCard">
                  <div
                    className="card-header d-flex align-items-center justify-content-between"
                    id="assetCardHeader"
                  >
                    <h5 className="mb-0" id="headerLabel">
                      Supplier Details
                    </h5>
                  </div>
                  <div className="card-body">
                    <div className="row mb-3">
                      <div className="col-md-4" id="assetFormLabel">
                        {/* <label className="form-label " htmlFor="collapsible-supplierType">
                          Type<span className="asterisk"> *</span>
                        </label>
                        <Autocomplete
                          fullWidth
                          id="supplierTypeList"
                          options={this.supplierTypeList}
                          value={this.state.supplierType}
                          defaultValue={this.state.supplierType}
                          getOptionLabel={(option) => option.type}
                          onChange={(event, value) => {
                            this.handleSupplierTypeChange(value);
                          }}
                          inputprops={{ style: { textTransform: "capitalize" } }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                            placeholder="Please Select"
                              variant="outlined"
                              required
                            />
                          )}
                        /> */}
                        <FormControl variant="outlined" fullWidth size="small">
                          <label
                            className="form-label "
                            htmlFor="collapsible-companyName"
                          >
                            Type<span className="asterisk"> *</span>
                          </label>
                          <Select
                            id="appointmentType"
                            value={this.state.supplierTypeId}
                            placeholder="Please Select"
                            required
                            onChange={(e) => {
                              this.handleSupplierTypeChange(e);
                            }}
                          >
                            {this.supplierTypeList.map((event, keyIndex) => {
                              return (
                                <MenuItem key={keyIndex} value={event.id}>
                                  {event.type}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </div>
                      <div className="col-md-4" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-fullname"
                        >
                          Name<span className="asterisk"> *</span>
                        </label>
                        <TextField
                          type="text"
                          className="textField"
                          fullWidth
                          id="basic-default-name"
                          variant="outlined"
                          value={this.state.name}
                          onChange={this.handleNameChange.bind(this)}
                        />
                      </div>
                      <div className="col-md-4" id="assetFormLabel">
                        {this.state.supplierType != null &&
                          this.state.supplierType === "Registered" ? (
                          <div className="col-md-12" id="assetFormLabel">
                            <label
                              className="form-label "
                              htmlFor="collapsible-fullname"
                            >
                              GSTN<span className="asterisk"> *</span>
                            </label>
                            <TextField
                              required
                              type="text"
                              className="textField"
                              fullWidth
                              id="basic-default-name"
                              variant="outlined"
                              value={this.state.gstn}
                              onChange={this.handleGstnChange.bind(this)}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <RefreshIcon
                                      className="verifyGstnBtn"
                                      onClick={(e) => this.getGstn()}
                                    />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </div>
                        ) : (
                          <div className="col-md-12" id="assetFormLabel">
                            <label
                              className="form-label "
                              htmlFor="collapsible-fullname"
                            >
                              GSTN
                            </label>
                            <TextField
                              type="text"
                              className="textField"
                              fullWidth
                              id="basic-default-name"
                              variant="outlined"
                              value={this.state.gstn}
                              onChange={this.handleGstnChange.bind(this)}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <RefreshIcon
                                      className="verifyGstnBtn"
                                      onClick={(e) => this.getGstn()}
                                    />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-4" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-fullname"
                        >
                          Email<span className="asterisk"> *</span>
                        </label>
                        <TextField
                          type="email"
                          className="textField"
                          fullWidth
                          id="basic-default-email"
                          variant="outlined"
                          aria-label="Email"
                          aria-describedby="basic-icon-default-email2"
                          value={this.state.email}
                          onChange={this.handleEmailChange.bind(this)}
                          validators={["required", "isEmail"]}
                          errormessages={[
                            "This field is required",
                            "Email id is not valid",
                          ]}
                          required
                        />
                      </div>
                      <div className="col-md-4" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-fullname"
                        >
                          Phone
                        </label>
                        <TextField
                          type="number"
                          className="textField"
                          fullWidth
                          id="basic-default-phone"
                          variant="outlined"
                          value={this.state.phone}
                          onChange={this.handlePhoneChange.bind(this)}
                        />
                      </div>
                      <div className="col-md-4" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-fullname"
                        >
                          PAN No<span className="asterisk"> *</span>
                        </label>
                        <TextField
                          type="text"
                          className="textField"
                          fullWidth
                          id="basic-default-panNo"
                          variant="outlined"
                          value={this.state.panNo}
                          onChange={this.handlePanNoChange.bind(this)}
                          validators={["required"]}
                          errormessages={["This field is required"]}
                          required
                        />
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-12" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-description"
                        >
                          Description
                        </label>
                        <textarea
                          name="collapsible-address"
                          className="form-control"
                          style={{
                            color: "black",
                            font: "inherit",
                            fontSize: "16px ",
                          }}
                          id="collapsible-address"
                          rows="4"
                          value={this.state.description}
                          onChange={this.handleDescriptionChange.bind(this)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row" style={{ marginTop: "1em" }}>
              <div className="col-md-12">
                <div className="card" id="organizationFormCard">
                  <div
                    className="card-header d-flex align-items-center justify-content-between"
                    id="assetCardHeader"
                  >
                    <h5 className="mb-0" id="headerLabel">
                      Address
                    </h5>
                  </div>
                  <div className="card-body">
                    <AddressWithTimezone
                      ref={this.addressRef}
                      onChange={this.handleAddressChange.bind(this)}
                      data={this.state.address}
                      action="create"
                      pageId="Geolocation"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row d-flex align-items-center justify-content-between">
              <div className="col-sm-12 mt-3 text-center">
                <CreateButton btnName="Create" type="submit" />
                &nbsp;&nbsp;
                <CancelIconButton onClick={(e) => this.createCancel()} />
              </div>
            </div>
          </ValidatorForm>
        </div>
      </>
    );
  }
  viewSupplier() {
    if (this.state.render === false) {
      return <div />;
    } else {
      return (
        <>
          <MenuWithBreadScrum
            breadCrumb={this.breadCrumb}
            navigate={this.props.navigate}
            domainObject={this.state.name}
            name="Supplier Details"
            title="Supplier"
            editCallback={this.editSupplierDetails.bind(this)}
            deleteCallback={this.deleteSupplierToBackend.bind(this)}
            getDeletePermission={this.state.getDeletePermission}
            getUpdatePermission={this.state.getUpdatePermission}
          />

          <Tabs
            defaultIndex={this.state.selectedTab}
            onSelect={(k) => this.setKey(k)}
            className="settingTab"
          >
            <TabList
              style={{ listStyle: "none" }}
              className="text-start d-flex justify-content-start settingTabList ps-0"
            >
              <Tab className="tabSetting hoverTab">Supplier Details</Tab>
              <Tab className="tabSetting hoverTab">
                Supplier assets{" "}
                {this.state.assetCount > 0 && `(${this.state.assetCount})`}
              </Tab>
            </TabList>
            <TabPanel>
              <div
                className="row"
                style={{ padding: "1em", marginTop: "-12px" }}
              >
                <div className="card" id="organizationFormCard">
                  <div className="row">
                    <div
                      className="card-header d-flex align-items-center justify-content-between"
                      id="assetCardHeader"
                    >
                      <h5 className="mb-0" id="headerLabel">
                        {this.state.name}
                      </h5>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4">
                          <div className="row pt-1">
                            <label
                              className="col-sm-4 col-form-label fw-bold"
                              htmlFor="basic-default-supplierType"
                              id="assetFormLabel"
                            >
                              Type
                            </label>
                            <div className="col-sm-8" id="OrganizationCol">
                              <span>{this.state.supplierType.type}</span>
                            </div>
                          </div>
                          <div className="row pt-2">
                            <label
                              className="col-sm-4 col-form-label fw-bold"
                              htmlFor="basic-default-name"
                              id="assetFormLabel"
                            >
                              Email
                            </label>
                            <div className="col-sm-8" id="OrganizationCol">
                              <span>{this.state.email}</span>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="row">
                            <div className="col-sm-12">
                              <div className="row">
                                <label
                                  className="col-sm-4 col-form-label fw-bold"
                                  htmlFor="basic-default-name"
                                  id="assetFormLabel"
                                >
                                  PAN NO
                                </label>
                                <div className="col-sm-8" id="OrganizationCol">
                                  <span>{this.state.panNo}</span>
                                </div>
                              </div>
                              <div className="row pt-2">
                                <label
                                  className="col-sm-4 col-form-label fw-bold"
                                  htmlFor="basic-default-name"
                                  id="assetFormLabel"
                                >
                                  Phone
                                </label>
                                <div className="col-sm-8" id="OrganizationCol">
                                  <span>{this.state.phone}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="row">
                            <label
                              className="col-sm-4 col-form-label fw-bold"
                              htmlFor="basic-default-name"
                              id="assetFormLabel"
                            >
                              GSTN
                            </label>
                            <div className="col-sm-8" id="OrganizationCol">
                              <span>{this.state.gstn}</span>
                            </div>
                          </div>
                          <div className="row pt-2">
                            <label
                              className="col-sm-4 col-form-label fw-bold"
                              htmlFor="basic-default-name"
                              id="assetFormLabel"
                            >
                              Status
                            </label>
                            <div className="col-sm-8" id="OrganizationCol">
                              <span>{this.state.supplierStatus}</span>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="row pt-2">
                            <label
                              className="col-sm-12 col-form-label fw-bold"
                              htmlFor="basic-default-name"
                              id="assetFormLabel"
                            >
                              Description
                            </label>
                            <br></br>
                            <div className="col-sm-12" id="OrganizationCol">
                              <span>{this.state.description}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr></hr>
                  <div className="row">
                    <div
                      className="card-header d-flex align-items-center justify-content-between"
                      id="assetCardHeader"
                    >
                      <h5 className="mb-0" id="headerLabel">
                        Address
                      </h5>
                    </div>
                    <div className="card-body">
                      {/* <div className="row">
                        <div className="col-md-7"> */}
                      <div className="row">
                        <div className="col-sm-12" id="OrganizationCol">
                          <span>
                            {Utils.getAddressAsText(this.state.address)}
                          </span>
                        </div>
                        <div className="col-md-12 mt-2">
                          <div className="row">
                            <div className="col-md-4">
                              <div className="row">
                                <label
                                  className="col-sm-4 col-form-label fw-bold"
                                  htmlFor="basic-default-name"
                                  id="assetFormLabel"
                                >
                                  Latitude
                                </label>
                                <div className="col-sm-8" id="OrganizationCol">
                                  <span>{this.state.address?.latitude}</span>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="row ">
                                <label
                                  className="col-sm-4 col-form-label fw-bold"
                                  htmlFor="basic-default-name"
                                  id="assetFormLabel"
                                >
                                  Longitude
                                </label>
                                <div className="col-sm-8" id="OrganizationCol">
                                  <span>{this.state.address?.longitude}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* </div>
                        </div> */}
                      </div>
                      {/* <hr></hr>
                      <div className="row">
                        <div
                          className="card-header d-flex align-items-center justify-content-between"
                          id="assetCardHeader"
                          style={{ marginLeft: "-12px" }}
                        >
                          <h5 className="mb-0" id="headerLabel">
                            Geolocation
                          </h5>
                        </div>
                        <div className="col-md-12">
                          <div className="row">
                            <div className="col-md-4">
                              <div className="row">
                                <label
                                  className="col-sm-4 col-form-label fw-bold"
                                  htmlFor="basic-default-name"
                                  id="assetFormLabel"
                                >
                                  Latitude
                                </label>
                                <div className="col-sm-8" id="OrganizationCol">
                                  <span>{this.state.address?.latitude}</span>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="row ">
                                <label
                                  className="col-sm-4 col-form-label fw-bold"
                                  htmlFor="basic-default-name"
                                  id="assetFormLabel"
                                >
                                  Longitude
                                </label>
                                <div className="col-sm-8" id="OrganizationCol">
                                  <span>{this.state.address?.longitude}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
                <div className="mt-4">
                  <BackButton
                    type="button"
                    style={{ backgroundColor: "#162c50", color: "#fff" }}
                    variant="contained"
                    onClick={(e) => this.viewCancel()}
                  >
                    Back
                  </BackButton>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div style={{ maxWidth: "100%" }}>
                <div className="row">
                  <div className="col md-12">
                    <div className="card">
                      <div className="row justify-content-between p-3">
                        <div className="d-flex col-12 col-lg-4 col-xl-4">
                          <div className="col-12 text-start totalResults">
                            <span>
                              Total Results: {Utils.formatIndianNumber(this.state.totalRecords)}
                            </span>
                          </div>
                        </div>
                        <div className="d-flex col-12 col-lg-8 col-xl-8">
                          <div className="col-12 text-end">
                            <span className="me-4">
                              <TextField
                                id="standard-search"
                                placeholder="Search"
                                type="search"
                                variant="standard"
                                value={this.state.search}
                                onChange={this.onSearchChange.bind(this)}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton
                                        onClick={this.getSupplierAssetsList.bind(
                                          this,
                                          0,
                                          this.state.showPerPage
                                        )}
                                      >
                                        <SearchIcon />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </span>
                            {this.state.supplierStatus === "Active" && (
                              <>
                                {this.profileType?.type !== "SUPPLIER" && (
                                  <PtsButton
                                    btnName="Create Asset"
                                    onClick={(e) => this.toCategoryDetails()}
                                    style={{ float: "right" }}
                                  />
                                )}
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="table-responsive paginationTableThead">
                        <table className="table text-start table-hover">
                          <thead className="paginationTableThead">
                            <tr>
                              <th scope="col fw-bold">Name</th>
                              <th scope="col fw-bold">Asset UID</th>
                              <th scope="col fw-bold">Asset Code</th>
                              <th scope="col fw-bold">Status</th>
                              <th scope="col fw-bold">Tracking Status</th>
                              <th scope="col fw-bold">Last Tracked</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.supplierAssetList?.map(
                              (rowData, index) => (
                                <tr
                                  key={index}
                                  onClick={(e) => this.viewAsset(e, rowData)}
                                  style={{
                                    backgroundColor:
                                      rowData.id === this.state.assetId
                                        ? "#e6effc"
                                        : "#fff",
                                    cursor: "pointer",
                                  }}
                                >
                                  {/* <td>{this.state.pageNo * this.state.showPerPage + index + 1}</td> */}
                                  <td style={{ width: "260px" }}>
                                    {rowData.name}
                                  </td>
                                  <td style={{ width: "260px" }}>
                                    {rowData.uid}
                                  </td>
                                  <td style={{ width: "260px" }}>
                                    {rowData.assetcode}
                                  </td>
                                  <td style={{ width: "260px" }}>
                                    {rowData.status}
                                  </td>
                                  <td style={{ width: "260px" }}>
                                    {this.assetTrackingStatus(
                                      rowData.trackingHistoryStatus
                                    )}{" "}
                                    {rowData.trackingHistoryStatus}
                                  </td>
                                  <td style={{ width: "260px" }}>
                                    {rowData.latestTrackingDate ? Utils.formatDateTime(rowData.latestTrackingDate) : ''}
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                      {this.state.totalRecords === 0 && (
                        <div className="row text-center p-2">
                          <h5>Data not Available</h5>
                        </div>
                      )}
                      {this.state.totalRecords > 10 && (
                        <div className="row justify-content-between pagination p-2">
                          <div className="pageSize col-4 text-start">
                            Page {this.state.pageNo + 1} of{" "}
                            {this.state.totalPages}
                          </div>
                          <div className="col-4 text-end">
                            <Pagination
                              showPerPage={this.state.showPerPage}
                              onPaginationChange={this.onPaginationChange.bind(
                                this
                              )}
                              total={this.state.totalRecords}
                              pageNo={this.state.pageNo}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <CatalogueDialog
                ref={this.catalogueDialogueRef}
                style={{ float: "right" }}
                onChange={this.toCreateAsset.bind(this)}
                pageId="supplierAssets"
              />
            </TabPanel>
          </Tabs>
        </>
      );
    }
  }
  editSupplier() {
    return (
      <>
        <MenuWithBreadScrum
          breadCrumb={this.breadCrumb}
          navigate={this.props.navigate}
          domainObject="Supplier"
          name="Edit Supplier"
        />
        <div className="row">
          <ValidatorForm
            className="text-start"
            ref="form"
            onSubmit={this.updateSupplierToBackend.bind(this)}
          >
            <div className="row">
              <div className="col-md-12">
                <div className="card " id="organizationFormCard">
                  <div
                    className="card-header d-flex align-items-center justify-content-between"
                    id="assetCardHeader"
                  >
                    <h5 className="mb-0" id="headerLabel">
                      Supplier Details
                    </h5>
                  </div>
                  <div className="card-body">
                    <div className="row mb-3">
                      <div className="col-md-4" id="assetFormLabel">
                        {/* <label className="form-label " htmlFor="collapsible-supplierType">
                          Type<span className="asterisk"> *</span>
                        </label>
                        <Autocomplete
                          fullWidth
                          id="supplierTypeList"
                          options={this.supplierTypeList}
                          value={this.state.supplierType}
                          defaultValue={this.state.supplierType}
                          getOptionLabel={(option) => option.type}
                          onChange={(event, value) => {
                            this.handleSupplierTypeChange(value);
                          }}
                          inputprops={{ style: { textTransform: "capitalize" } }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Type "
                              variant="outlined"
                              required
                            />
                          )}
                        /> */}
                        <FormControl variant="outlined" fullWidth size="small">
                          <label
                            className="form-label "
                            htmlFor="collapsible-companyName"
                          >
                            Type<span className="asterisk"> *</span>
                          </label>
                          <Select
                            id="appointmentType"
                            value={this.state.supplierTypeId}
                            placeholder="Please Select"
                            required
                            onChange={(e) => {
                              this.handleSupplierTypeChange(e);
                            }}
                          >
                            {this.supplierTypeList.map((event, keyIndex) => {
                              return (
                                <MenuItem key={keyIndex} value={event.id}>
                                  {event.type}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </div>
                      <div className="col-md-4" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-fullname"
                        >
                          Name<span className="asterisk"> *</span>
                        </label>
                        <TextField
                          type="text"
                          className="textField"
                          fullWidth
                          id="basic-default-name"
                          variant="outlined"
                          value={this.state.name}
                          onChange={this.handleNameChange.bind(this)}
                        />
                      </div>
                      <div className="col-md-4" id="assetFormLabel">
                        {this.state.supplierType != null &&
                          this.state.supplierType === "Registered" ? (
                          <div className="col-md-12" id="assetFormLabel">
                            <label
                              className="form-label "
                              htmlFor="collapsible-fullname"
                            >
                              GSTN<span className="asterisk"> *</span>
                            </label>
                            <TextField
                              required
                              type="text"
                              className="textField"
                              fullWidth
                              id="basic-default-name"
                              variant="outlined"
                              value={this.state.gstn}
                              onChange={this.handleGstnChange.bind(this)}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <RefreshIcon
                                      className="verifyGstnBtn"
                                      onClick={(e) => this.getGstn()}
                                    />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </div>
                        ) : (
                          <div className="col-md-12" id="assetFormLabel">
                            <label
                              className="form-label "
                              htmlFor="collapsible-fullname"
                            >
                              GSTN
                            </label>
                            <TextField
                              type="text"
                              className="textField"
                              fullWidth
                              id="basic-default-name"
                              variant="outlined"
                              value={this.state.gstn}
                              onChange={this.handleGstnChange.bind(this)}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <RefreshIcon
                                      className="verifyGstnBtn"
                                      onClick={(e) => this.getGstn()}
                                    />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-4" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-fullname"
                        >
                          Email<span className="asterisk"> *</span>
                        </label>
                        <TextField
                          type="email"
                          className="textField"
                          fullWidth
                          id="basic-default-email"
                          variant="outlined"
                          aria-label="Email"
                          aria-describedby="basic-icon-default-email2"
                          value={this.state.email}
                          onChange={this.handleEmailChange.bind(this)}
                          validators={["required", "isEmail"]}
                          errormessages={[
                            "This field is required",
                            "Email id is not valid",
                          ]}
                          required
                        />
                      </div>
                      <div className="col-md-4" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-fullname"
                        >
                          Phone
                        </label>
                        <TextField
                          type="number"
                          className="textField"
                          fullWidth
                          id="basic-default-phone"
                          variant="outlined"
                          value={this.state.phone}
                          onChange={this.handlePhoneChange.bind(this)}
                        />
                      </div>
                      <div className="col-md-4" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-fullname"
                        >
                          PAN No<span className="asterisk"> *</span>
                        </label>
                        <TextField
                          type="text"
                          className="textField"
                          fullWidth
                          id="basic-default-panNo"
                          variant="outlined"
                          value={this.state.panNo}
                          onChange={this.handlePanNoChange.bind(this)}
                          validators={["required"]}
                          errormessages={["This field is required"]}
                          required
                        />
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-12" id="assetFormLabel">
                        <label
                          className="form-label "
                          htmlFor="collapsible-description"
                        >
                          Description
                        </label>
                        <textarea
                          name="collapsible-address"
                          className="form-control"
                          style={{
                            color: "black",
                            font: "inherit",
                            fontSize: "16px ",
                          }}
                          id="collapsible-address"
                          rows="4"
                          value={this.state.description}
                          onChange={this.handleDescriptionChange.bind(this)}
                        />
                      </div>
                    </div>
                    <div className="col-md-4 mt-1" id="assetFormLabel">
                      {/* <span className="ms-4">
                        <ToggleButton
                          value={this.state.isStatus ? "Active" : "InActive"}
                          className="ToggleButtonActive"
                          onChange={this.handleStatusChange.bind(this)}
                          style={
                            this.state.isStatus
                              ? {
                                  background: "#0B6F9D",
                                  color: "#fff",
                                  height: "33px",
                                  width: "80px",
                                  borderRadius: "5px",
                                  textTransform: "none",
                                }
                              : {
                                  background: "#D7DBDD",
                                  color: "#000",
                                  height: "33px",
                                  width: "80px",
                                  borderRadius: "5px",
                                  textTransform: "none",
                                }
                          }
                        >
                          {this.state.isStatus ? "Active" : "InActive"}
                        </ToggleButton>
                      </span> */}
                      <div className="row d-flex">
                        <label
                          className="col-sm-2 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Status
                        </label>
                        <div className="col-sm-10 d-flex">
                          <span className="custom-radio">
                            <input
                              type="radio"
                              id="active"
                              name="custLocationStatus"
                              value="Active"
                              checked={this.state.supplierStatus === "Active"}
                              onChange={this.handleStatusChange}
                            />
                            <label
                              className="col-form-label ps-1"
                              htmlFor="yes"
                            >
                              Active
                            </label>
                          </span>
                          <span className="ms-3 custom-radio">
                            <input
                              type="radio"
                              id="inActive"
                              name="custLocationStatus"
                              value="InActive"
                              checked={this.state.supplierStatus === "InActive"}
                              onChange={this.handleStatusChange}
                            />
                            <label className="col-form-label ps-1" htmlFor="no">
                              InActive
                            </label>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row" style={{ marginTop: "1em" }}>
              <div className="col-md-12">
                <div className="card" id="organizationFormCard">
                  <div
                    className="card-header d-flex align-items-center justify-content-between"
                    id="assetCardHeader"
                  >
                    <h5 className="mb-0" id="headerLabel">
                      Address
                    </h5>
                  </div>
                  <div className="card-body">
                    <AddressWithTimezone
                      ref={this.addressRef}
                      onChange={this.handleAddressChange.bind(this)}
                      data={this.state.address}
                      action="edit"
                      pageId="Geolocation"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row d-flex align-items-center justify-content-between custBut">
              <div className="col-sm-12 mt-3 text-center">
                <SaveButton id="saveButton" type="submit">
                  {" "}
                  Save{" "}
                </SaveButton>
                &nbsp;&nbsp;
                <CancelIconButton onClick={(e) => this.editCancel()} />
              </div>
            </div>
          </ValidatorForm>
        </div>
      </>
    );
  }
}
export default withRouter(Supplier);
